// hooks/useAddToCart.ts
import { useCart } from "../context/CartContext";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const useAddToCart = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = (product: any, selectedImage: string) => {
    const accessToken = Cookies.get("access_token");
    if (accessToken) {
      console.log(product)
      addToCart({
        id: product.id,
        image: selectedImage || product.image,
        name: product.name,
        user: product.nickname,
        price: product.price,
        originalPrice: product.originalPrice,
        category: product.category,
        quantity: 1,
        description: product.description,
        usageInstructions: product.usageInstructions,
        tags: product.tags || [],
        star: product.star || 0,
        review: product.review || 0,
        profileImageUrl: product.profileImageUrl,
      });
      toast.success("상품이 장바구니에 추가되었습니다.");
    } else {
      toast.error("로그인이 필요합니다.");
      navigate("/login");
    }
  };

  return handleAddToCart;
};

export default useAddToCart;
